











































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { filter as filterObj, map as mapObj } from '@/utils/object'
import vClickOutside from 'v-click-outside'

interface OptGroup { [groupName: string]: string[] }

@Component<DropMenu>({
    directives: {
        clickOutside: vClickOutside.directive
    },
    model: {
        prop: 'selected',
        event: 'change'
    }
})
export default class DropMenu extends Vue {

    @Prop(String) public selected?: string
    @Prop(String) public title?: string
    @Prop() public options!: string[] | OptGroup
    @Prop(Function) public remove?: () => void
    @Prop(Boolean) public up?: boolean
    @Prop(Boolean) public disabled?: boolean

    public open = false

    public convertOptions = (value) => {
        if (typeof value === "object") {
            return value
        } else {
            return {key: value, value}
        }
    }

    public get label() {
        return this.title
    }

    public get isGrouped() {
        return !(this.options instanceof Array)
    }

    public get optGroups() {
        if (this.isGrouped) {
            return mapObj(
                filterObj(
                    this.options as OptGroup,
                    (opts) => opts.length > 0
                    ),
            (array) => {
                    return array.map(this.convertOptions)
                }
            )
        } else {
            // TODO: I don't like this, but it'll have to stand until we can clean up
            return { '': (this.options as Array<any>).map(this.convertOptions)}
        }
    }

    public selectOption(key: string) {
        this.$emit('change', key)
        this.open = false
    }

    public toggle() {
        this.open = !this.open
    }
}
